module.exports = __webpack_public_path__ + "public/img/pickInfo.db3f99a4.png";